var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 35,
    fill: "#8CFFE5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 20.5435V42.2174C17.5 46.6356 21.0817 50.2174 25.5 50.2174H52.5",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.641 20.5435V44.1304C18.641 46.8024 20.76 48.9795 23.4093 49.0729L23.5867 49.0761H52.4997V51.3587H23.5867C19.6634 51.3587 16.4702 48.2331 16.3613 44.3362L16.3584 44.1304V20.5435H18.641Z",
    fill: "#3B3A40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.05 22.9707L51.9712 24.2033L41.7595 40.1195C41.3929 40.6908 40.6193 40.812 40.0972 40.4035L40.0127 40.3304L32.8109 33.4859L26.0809 43.2563L24.2012 41.9612L31.6897 31.0917C32.0655 30.5462 32.8176 30.4397 33.3283 30.8366L33.4158 30.9119L40.584 37.7247L50.05 22.9707Z",
    fill: "#3B3A40"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.4d7793db65f3a4420215541753b390c2.svg";
export { ForwardRef as ReactComponent };